import React from 'react';

const SingleCheckButtons = ({
    name,
    options = [],
    value = "",
    onChange,
    group = null
}) => {
    const handleToggle = (option) => {
        // Toggle off if already selected, or pass the selected string option
        const newValue = value === option ? "" : option;
        onChange(name, newValue, group);
    };

    return (
        <div className="flex flex-wrap gap-2">
            {options.map((option) => {
                const isSelected = value === option;
                return (
                    <button
                        key={option}
                        type="button"
                        onClick={() => handleToggle(option)}
                        className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors border ${isSelected
                            ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                            }`}
                    >
                        {isSelected && <span className="mr-1">✓</span>}
                        {option}
                    </button>
                );
            })}
        </div>
    );
};

export default SingleCheckButtons;